import { Injectable } from '@angular/core';

import {
  BusinessProfile,
  PermissionType,
  ProfileSelectorDetails
} from '@com-delta-idp/mnx-capability-profile-selector-ui';
import {
  DashboardResponse,
  loginAndGetDashboardResponse,
  OauthAEMConfig
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BUSINESS_OPTIONS } from '../constants/profile-selector-constants';
import { ProfileSelectorAEM } from '../models/profile-selector-aem.interface';
import { ProfileSelectorAdapterHelperService } from './profile-selector-adapter-helper.service';
@Injectable({ providedIn: 'root' })
export class ProfileSelectorAdapterService extends ProfileSelectorAdapterHelperService {
  getProfileSelectorContent(
    response: Partial<DashboardResponse> | loginAndGetDashboardResponse,
    aemResponse: ProfileSelectorAEM,
    authConfig: OauthAEMConfig
  ): ProfileSelectorDetails {
    this.dashboardResponse = response;
    this.deconstructResponse(response, aemResponse);
    this.postCorporateFlag = !!authConfig.POST_CORPORATE_ID_FLAG;
    this.transformPageHeader();
    this.transformPersonalProfileView();
    this.transformBusinessProfileView(authConfig);
    this.skyBonusNuTravelAdapterService.transformNuTravelObject(
      this.personalProfileView,
      this.businessProfileView,
      this.url,
      authConfig
    );
    return {
      pageHeader: this.pageHeader,
      personalProfile: this.personalProfileView,
      businessProfile: this.businessProfileView,
      pageFooter: this.profileSelectorPageFooter
    };
  }

  transformBusinessProfileView(authConfig: OauthAEMConfig): void {
    this.businessProfileView = {
      title: this.businessTitle,
      businessProfile: this.transformBusinessProfile(authConfig)
    };
  }

  transformBusinessProfile(authConfig: OauthAEMConfig): BusinessProfile[] {
    return (
      this.companyName?.map((name, index) => ({
        companyName: this.profileSelectorUtilService.getName(name),
        displayName: this.profileSelectorUtilService.getDisplayName(
          name,
          this.crprtAgrmntId[index]
        ),
        selectedState: false,
        permissionTypes: this.getBusinessPermissionList(
          this.permType ? this.permType[index] : '',
          index
        ),
        partnerId: this.getBusinessOptions(
          BUSINESS_OPTIONS.partnerId,
          this.crprtAgrmntTypeCode[index],
          this.isCorpAgreeIdPresent(this.crprtAgrmntId[index]),
          this.pgmType[index],
          this.program[index],
          this.isOaSME(
            name,
            this.isCorpAgreeIdPresent(this.crprtAgrmntId[index])
          ).isOaSmeAccount
        ) as string,
        restrictOnePax: this.getBusinessOptions(
          BUSINESS_OPTIONS.restrictOnePax,
          this.crprtAgrmntTypeCode[index],
          this.isCorpAgreeIdPresent(this.crprtAgrmntId[index]),
          this.pgmType[index],
          this.program[index],
          this.isOaSME(
            name,
            this.isCorpAgreeIdPresent(this.crprtAgrmntId[index])
          ).isOaSmeAccount
        ) as boolean,
        disableMiles: this.getBusinessOptions(
          BUSINESS_OPTIONS.disableMiles,
          this.crprtAgrmntTypeCode[index],
          this.isCorpAgreeIdPresent(this.crprtAgrmntId[index]),
          this.pgmType[index],
          this.program[index],
          this.isOaSME(
            name,
            this.isCorpAgreeIdPresent(this.crprtAgrmntId[index])
          ).isOaSmeAccount
        ) as boolean,
        isOaSmeAccount: this.isOaSME(
          name,
          this.isCorpAgreeIdPresent(this.crprtAgrmntId[index])
        ).isOaSmeAccount,
        displayInlineText: this.getBusinessOptions(
          BUSINESS_OPTIONS.displayInlineText,
          this.crprtAgrmntTypeCode[index],
          this.isCorpAgreeIdPresent(this.crprtAgrmntId[index]),
          this.pgmType[index],
          this.program[index],
          this.isOaSME(
            name,
            this.isCorpAgreeIdPresent(this.crprtAgrmntId[index])
          ).isOaSmeAccount
        ) as string,
        userId: this.userId[index],
        redirectUrl: this.getRedirectUrl(name, index, authConfig),
        corporateId: this.crprtAgrmntId[index]
      })) ?? ({} as BusinessProfile[])
    );
  }

  getBusinessPermissionList(type: string, index: number): PermissionType[] {
    const { program, title, description, urlToRedirect } =
      this.getBusinessListHelper(index);
    const permissionArray = [this.setDefaultBusiness()];
    const selectedState = false;
    const permType = type;
    if (this.profileSelectorUtilService.displayBusinessPath(type, program)) {
      permissionArray.push({
        title,
        description,
        urlToRedirect,
        selectedState,
        permType
      });
    } else if (
      this.profileSelectorUtilService.displayOnlySkyBonusPath(type, program)
    ) {
      permissionArray.pop();
      permissionArray.push({
        title,
        description,
        urlToRedirect,
        selectedState,
        permType
      });
    } else if (
      this.profileSelectorUtilService.hasAdminAndSkyBonusPath(type, program)
    ) {
      return this.permissionListAdminAndSkyBonusPath(type);
    }
    return permissionArray;
  }
}
